export default {
  set(state, { data }) {
    state.vouchers = data;
  },
  show(state, { data }) {
    state.voucher = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}